import script from "./FinishFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishFormView.vue?vue&type=script&setup=true&lang=js"

import "./finishForm.css?vue&type=style&index=0&id=28ff35eb&scoped=true&lang=css&external"
import "../shared/routesMobileCommon.css?vue&type=style&index=1&id=28ff35eb&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ff35eb"]])

export default __exports__